<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2024-08-13 14:15:36
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-09-03 16:44:44
 * @Description: 导出提示框
 * @FilePath: \haozhang_pro\src\pages\pageInvoice\exportTip.vue
-->
<template>
  <BaseDialog
    title = "确认筛选范围"
    :showVisible = "isShow"
    @close = "isShow = false"
    @confirm = "confirm"
  >
    <template v-slot:content>
      <div class="export_tip_item">
         <div class="export_tip_item__title">时间范围：</div>
         <span class="export_tip_item__value">{{ formData.startTime?`${ formData.startTime }至 ${ formData.endTime }`:"全部范围" }}</span>
      </div>
      <div class="export_tip_item">
         <div class="export_tip_item__title">发票种类：</div>
         <span class="export_tip_item__value">{{ `${ formData.invoiceLabel || '全部范围' }` }}</span>
      </div>
      <div class="export_tip_item">
         <div class="export_tip_item__title">凭证状态：</div>
         <span class="export_tip_item__value" style="color: #F56C6C;">{{ formData.voucherChiefLabel || "全部范围" }}</span>
      </div>
      <div class="export_tip_item">
         <div class="export_tip_item__title">来源：</div>
         <span class="export_tip_item__value">{{ formData.sourceLabel || "全部范围" }}</span>
      </div>
      <div class="export_tip_item">
         <div class="export_tip_item__title">套用模板：</div>
         <span class="export_tip_item__value">{{ formData.templateLabel || "全部范围" }}</span>
      </div>
    </template>
  </BaseDialog>
</template>
<script>
import BaseDialog from '@/components/dialog/BaseDialog.vue';
export default {
  props: {
    showVisible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    BaseDialog
  },
  computed: {
    isShow: {
      get() {
        return this.showVisible;
      },
      set(val) {
        this.$emit('update:showVisible', val);
      }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      this.isShow = false;
    }
  }
};
</script>
<style lang="less">
.export_tip_item {
  display: flex;
  font-weight: 400;
  &:not(:first-child) {
    margin-top: 10px;
  }
  &__title {
    width: 72px;
    text-align: right;
    color: #666666;
    flex-shrink: 0;
  }
  &__value {
    color: #333333
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pageInvoice/exportTip.vue